import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, message, Typography, Layout, Row, Col,Modal,Select } from 'antd';
import PinInput from 'react-pin-input';
import { onBackendVerifyLogin, onBackendVerifyLoginDtk } from '../Controller/Login';
import { onCreateNewOTP,onGetOtpByMobile,onUpdateOtpStatus} from '../Controller/Otp'
import {  onCreateUser } from "../Controller/Management/UserProf_Ctrl"
import { useDispatch } from 'react-redux';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
// import md5 from "md5";
import "../css/Login.css"
import { GetTranslation } from '../Models/shared/general';
// root pwd x_t3ra@81a7xq
import moment from 'moment';
const { Content } = Layout
// //====== IMPORT CSS LIB =========
// import "antd/dist/antd.css";

export default function Login() {
    // const isBroadcaster = new URLSearchParams(window.location.search).get("BC");
    const loginFormRef = useRef(null)
    const loginUserref = useRef(null)
    const loginPassref = useRef(null)

    const [countryCode, setCountryCode] = useState("60");
    const [mobilenum, setmobilenum] = useState("");

    const [newUserid, setnewUserid] = useState("");
    const [newDisplayname, setnewDisplayname] = useState("");
    const [newPassword1, setnewPassword1] = useState("");
    const [newPassword2, setnewPassword2] = useState("");

    const [inputpassword1, setInputpassword1] = useState("password");
    const [inputpassword2, setInputpassword2] = useState("password");

    const [ProgressStatus, setPogressStatus]                      = useState(false);
    const [modalCreateStep1, setmodalCreateStep1]                 = useState(false); 
    const [modalCreateStep2, setmodalCreateStep2]                 = useState(false); 
    const [modalCreateStep3, setmodalCreateStep3]                 = useState(false); 
    const devicetoken = new URLSearchParams(window.location.search).get("dtk") || ""
    const fromAPP = (window.location.host == window.parent.location.host ? 1 : 1)
    //console.log('fromAPP ', fromAPP)
    const [loginForm] = Form.useForm()
    const [formLoading, setformLoading] = useState(false)
    const userlang                          = navigator.language || navigator.userLanguage;
    

    const [conddisable, setConddisable] = useState(true);      // CONDITIONS
    const [timer, setTimer] = useState('00:00');
    const [requestimes, setrequestimes] = useState(1);

    var secondsToGo = 0;
    const Ref = useRef(null);

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        return {
            total, minutes, seconds
        };
    }

    const startTimer = (e) => {
        let { total, minutes, seconds }
            = getTimeRemaining(e);
        if (total >= 0) {
            setConddisable(true);
            // update the timer
            // check if less than 10 then we need to 
            // add '0' at the begining of the variable
            setTimer(
                (minutes > 9 ? minutes : '0' + minutes) + ':'
                + (seconds > 9 ? seconds : '0' + seconds)
            )
        }
        else {
            setConddisable(false);
        }
    }

    const clearTimer = (e) => {

        // If you adjust it you should also need to
        // adjust the Endtime formula we are about
        // to code next    
        //setTimer('00:60');
        // If you try to remove this line the 
        // updating of timer Variable will be
        // after 1000ms or 1sec
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = id;
    }

    const getDeadTime = () => {
        let deadline = new Date();

        // This is where you need to adjust if 
        // you entend to add more time
        deadline.setSeconds(deadline.getSeconds() + secondsToGo);
        return deadline;
    }

    const CountDownTime = () => {

        //  console.log("asd1",timer)
        useEffect(() => {
            clearTimer(getDeadTime());
        }, []);
        return (
            timer
        )
    }

    useEffect( async () => {
        //20220901 steven add, auto login with devicetoken
        if(fromAPP === 1 && devicetoken != ""){
            //call API
            setformLoading(true)
            let val = { 'dtk' : devicetoken }
            const result = await onBackendVerifyLoginDtk(val);
            await buffer()
            if (result.status === 'ok') {
                console.log('login',result.data)
                dispatch({ type: "sign_in", payload: result.data });
                localStorage.removeItem("taskfilter")
                localStorage.removeItem("tasktype")
                localStorage.removeItem("taskname")
            }
            else {
                setformLoading(false)
                //no need alert "invalid dtk"
                // message.error(result.msg ? result.msg : "Could not log in");
                loginUserref.current.focus({ cursor: "all" })
            }
        }
        //======= SET CSS STYLE ========
        if (window.location.pathname !== "/") {
            message.warn("You're not logged in yet, login first")
        }
        window.addEventListener("beforeunload", () => { setformLoading(true); console.log("beforeunload") })
        if (loginFormRef.current && loginUserref.current) {
            setTimeout(() => {
                loginFormRef.current.scrollIntoView()
                loginUserref.current.focus()
            }, 500);
        }
    }, [])

    const { Title } = Typography;
    const dispatch = useDispatch();

    const buffer = async () => {
        return new Promise(res => setTimeout(res, 1500))
    }
    const onPress = async (val) => {
        setformLoading(true)
        val.dtk = devicetoken;
        const result = await onBackendVerifyLogin(val);
        
        await buffer()
        if (result.status === 'ok') {
            console.log('login',result.data)
            localStorage.setItem("naxver","1.1")  
            dispatch({ type: "sign_in", payload: result.data });
            localStorage.removeItem("taskfilter")
            localStorage.removeItem("tasktype")
            localStorage.removeItem("taskname")
        }
        else {
            setformLoading(false)
            message.error(result.msg ? result.msg : "Could not log in");
            loginUserref.current.focus({ cursor: "all" })
        }

    };
     //====== SELECTBOX ONCHANGE ======
     const onChangeCountryCode = (e) => {
        setCountryCode(e);
    }
    const onChangeMobileNum = (e) => {

        var mobilenum = e.target.value.toString()
        setmobilenum(mobilenum);
    }

    const showCreateModal1 = (val,result) => {

        setmodalCreateStep1(true)
    }

    const cancelModal = (val,result) => {

        setmodalCreateStep1(false)
        setmodalCreateStep2(false)
        setmodalCreateStep3(false)
    }
   
    const showCreateModal2 = async(val,result) => {

        let phoneNumber = mobilenum.trim()
        if (phoneNumber == undefined || phoneNumber == "") {
            alert("Please Key In Phone Number");
            return;
        }
    
       
        //====== VALIDATE FIELDS ======
        //===== MALAYSIA ======
        if (countryCode == "60") {
            if (`${countryCode}${phoneNumber}`.length <= 9) {
                alert("Please Key In Correct Format (9 length)");
                return;
            }
        }
        //====== THAILAND ======
        else if (countryCode == "66") {
            if (`${countryCode}${phoneNumber}`.length <= 7) {
                alert("Please Key In Correct Format (7 length)");
                return;
            }
        }
        if(phoneNumber.charAt(0) == 0)
        {
            phoneNumber = phoneNumber.substring(1);
        }
        let submitphonenum = countryCode.toString()+phoneNumber.toString()
        let data = {
        mobilenum       :   submitphonenum,
        action          :   "New Register Request OTP",
        status          :   1
       }
       setPogressStatus(true)
      var result = await onCreateNewOTP(data)

      if(result.msg == "Create Otp successfully")
      {
        setmodalCreateStep2(true)

        setmodalCreateStep1(false)

        setConddisable(true)
        setTimer('02:00');
        secondsToGo = 120
        clearTimer(getDeadTime());
        setrequestimes(2)
      }
      else if(result.msg == "Mobile had exists")
      {
          alert("Mobile exists, Please change")
      }
       
      setPogressStatus(false)
    }
    const showCreateModal3 = async (val) =>{

        let data={
            mobilenum       : `${countryCode}${mobilenum.trim()}`
        }
        setPogressStatus(true)
        const result = await onGetOtpByMobile(data);

        var temptime = moment().subtract(2,"minutes")
        var temptime2 = moment(temptime).unix()

        if(result.status == "ok")
        {
            if(result.data[0].otptime > temptime2 )
            {
                if(result.data[0].otp == val)
                {
                    // alert("OTP Correct")
                    let data1={
                        mobilenum       : `${countryCode}${mobilenum.trim()}`,
                        status          : 0
                    }
                    onUpdateOtpStatus(data1)
                    setmodalCreateStep2(false)
                    setmodalCreateStep3(true)
                }
                else
                {
                    alert("OTP Wrong, Please Try Again")
                }
            }
            else
            {
                if(result.data[0].otp == val)
                {
                    
                    alert("OTP Expired")
                    let data1={
                        mobilenum       : `${countryCode}${mobilenum}`,
                        status          : 0
                    }
                    onUpdateOtpStatus(data1)
                }
                else
                {
                    alert("OTP Wrong, Please Try Again")
                }
               
            }
        }
        else
        {
            alert("OTP Wrong, Please Try Again")
        }
        setPogressStatus(false)
    }

    const regenOTP = async (val) =>{

        let data1={
            mobilenum       : `${countryCode}${mobilenum.trim()}`,
            status          : 0
        }
        onUpdateOtpStatus(data1)

        let data = {
            mobilenum       :   `${countryCode}${mobilenum.trim()}`,
            action          :   "New Register Request OTP",
            status          :   1
           }
           onCreateNewOTP(data)
           setConddisable(true)
           setTimer('02:00');
           secondsToGo = 120
           clearTimer(getDeadTime());
           setrequestimes(2)
    }
    
    const CreateNewUser = async(val) => {

        let tempuserid = newUserid.toString().trim()
        let tempdisplayname = newDisplayname.toString().trim()
        let temppass1 = newPassword1.toString().trim()
        let temppass2 = newPassword2.toString().trim()

        if(temppass1 != temppass2)
        {
            alert("Password did not match !")
        }
        else
        {
            let data = {
                userid      : tempuserid,
                password    : temppass1,
                parentid    : "root",
                companyid   : "outsider",
                permid      : "",
                markingcode : tempdisplayname,
                status      : 1,
                isapiuser   : 0,
                reportto    : "",
                contactno   : `${countryCode}${mobilenum.trim()}`,
                shift       : "public",
                department  : "public",
                grouping    : "private",
                devicetoken : []
            }
            setPogressStatus(true)
            var result = await onCreateUser(data)

            if(result.msg == "User had exists")
            {
                alert("User had exists, Please change")
            }
            else if(result.msg == "Create user successfully")
            {
                alert("Create User Successful")
                cancelModal()
            }
            else
            {
                alert("Create User Fail!")
            }
            setPogressStatus(false)
           
        }
    }

    const checkShowHidePassword1 = async (val) =>{
        const tempvalue = inputpassword1
        if(tempvalue == "password")
        {
            setInputpassword1("")
        }
        else
        {
            setInputpassword1("password")
        }
    }
    const checkShowHidePassword2 = async (val) =>{
        const tempvalue = inputpassword2
        if(tempvalue == "password")
        {
            setInputpassword2("")
        }
        else
        {
            setInputpassword2("password")
        }
    }
   

    return (

        <Layout style={{ background: "rgba(0,0,0,0)" }}>
            <Content>
                <Row
                    ref={loginFormRef}
                    style={{ minHeight: "85vh" }}
                    align="middle" justify="center">
                    <Col
                        xl={{ span: 4 }}
                        lg={{ span: 6 }}
                        md={{ span: 7 }}
                        xs={{ span: 10 }}
                    >
                        <Form
                            form={loginForm}
                            size="large"
                            name="loginform"
                            onFinish={onPress}
                            scrollToFirstError
                            onFinishFailed={(va, er, od) => { loginUserref.current.focus({ cursor: "all" }); }}
                            className="loginForm"
                            requiredMark="optional"
                            layout="horizontal"
                        >
                            <p className="legend">Login</p>
                            <Row >
                                <Col span={24}>
                                    <Form.Item
                                        validateFirst
                                        labelAlign="right"
                                        preserve={false}
                                        name="userid"
                                        rules={[
                                            {
                                                required: true, message: "Field marked required"
                                            }, {
                                                whitespace: true,
                                                message: "Upfront whitespace"
                                            }
                                        ]}
                                    >
                                        <form onSubmitCapture={(e) => {
                                            e.preventDefault()
                                        }}>
                                            <Input
                                                bordered={false}
                                                ref={loginUserref}
                                                onPressEnter={() => { loginPassref.current.focus({ cursor: "end" }) }}
                                                // suffix={<UserOutlined />}
                                                placeholder="User Name"
                                                disabled={formLoading}
                                            />
                                        </form>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row >
                                <Col span={24}>
                                    <Form.Item
                                        labelAlign="right"
                                        name="pass"
                                        rules={[
                                            { required: true, message: "Field marked required" },
                                            {
                                                whitespace: true,
                                                message: "Field contains only blanks"
                                            }
                                        ]}
                                    >
                                        <form onSubmitCapture={(e) => {
                                            e.preventDefault();
                                            return false
                                        }}
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                return false
                                            }}
                                        >
                                            <Input
                                                ref={loginPassref}
                                                bordered={false}
                                                onPressEnter={() => { loginForm.submit() }}
                                                // suffix={<LockOutlined />}
                                                disabled={formLoading}
                                                type="password"
                                                placeholder="Password"
                                            />
                                        </form>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row justify="space-around">
                                <Form.Item className={"loginButtonFormItem"}>
                                    <Button
                                        type="link"
                                        loading={formLoading}
                                        onClick={() => { loginPassref.current.focus() }}
                                        htmlType="submit"
                                        style={{ backgroundColor: "rgba(0,0,0,0)" }}
                                    >
                                        {formLoading ? "" : "Login"}
                                    </Button>
                                </Form.Item>
                            </Row>
                        </Form>
                        <Row
                        justify="space-around"
                       >
                            {/* <div className={"createForm"}>
                            <Button
                            type="link"
                            onClick={() => {showCreateModal1()}} >
                                Create New Account
                            </Button>
                            </div> */}
                            <Backdrop
                                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                                open={ProgressStatus}
                            >
                             
                            <Modal
                            title="Create Account"
                            visible={modalCreateStep1}
                            destroyOnClose ="true"
                            onOk={showCreateModal2}
                            onCancel={cancelModal}
                            className='newModalStyle'>

                            <div >
                                <Select style={{width:"25%"}} value={countryCode} onChange={(e) => onChangeCountryCode(e)}>
                                    <option value="66">+66</option>
                                    <option value="60">+60</option>
                                </Select>
                                    <Input
                                        type="tel"
                                        onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                                        name="sign_in_tel"
                                        placeholder={GetTranslation(userlang,'Phone Number')}
                                        autoComplete="off"
                                        style={{width:"75%"}}
                                        onChange={(e) => onChangeMobileNum(e)}
                                    />
                            </div>
                          
                       
                            </Modal>
                            <Modal
                            title="OTP"
                            destroyOnClose={true}
                            visible={modalCreateStep2}
                            onCancel={cancelModal}
                            footer= {
                                <Button type='danger' onClick={cancelModal}>Cancel</Button>
                            }>
                                <PinInput
                                 length={6} 
                                 focus={true}
                                 type='numeric'
                                 inputMode='number'
                                 //inputStyle={{borderColor: 'red'}}
                                 inputFocusStyle={{borderColor: 'blue'}}
                                 onComplete={(value) => {showCreateModal3(value)}}>
                                    
                                </PinInput>
                            <br/>
                            <div>
                                {
                                    conddisable ?
                                    <>
                                    <a style={{color:"lightgrey", cursor:"default"}}> Re-Send OTP</a>
                                    </>
                                    :
                                    <>
                                    <a style={{textDecoration:"underline"}} onClick={(value) => {regenOTP(value)}}> Re-Send OTP</a>
                                    </>
                                }
                                
                                <time id="timeEl" dateTime="PT0H0M0S" >  :  {CountDownTime()}</time>
                            </div>
                            </Modal>
                            
                            <Modal
                            title="Set Up User Name and Password"
                            destroyOnClose={true}
                            visible={modalCreateStep3}
                            onOk={CreateNewUser}
                            onCancel={cancelModal}
                            >
                                <div>
                                <Input  style={{width:"95%"}} onChange={(e) => setnewUserid(e.target.value.toString())} placeholder='User ID'></Input>
                                </div>
                                <br/>
                                <div>
                                <Input  style={{width:"95%"}} onChange={(e) => setnewDisplayname(e.target.value.toString())} placeholder='Display Name'></Input>
                                </div>
                                <br/>
                                <div>
                                <Input style={{width:"75%"}} onChange={(e) => setnewPassword1(e.target.value.toString())} type={inputpassword1} placeholder='Password'></Input>
                                <Button style={{widht:"20%"}} onClick={(value) => checkShowHidePassword1(value)} > {inputpassword1 == "password" ? "Show" : "Hide"}</Button>
                                </div>
                                <br/>
                                <div>
                                <Input style={{width:"75%"}} onChange={(e) => setnewPassword2(e.target.value.toString())} type={inputpassword2} placeholder='Confirm Password'></Input>
                                <Button style={{widht:"20%"}} onClick={(value) => checkShowHidePassword2(value)} > {inputpassword2 == "password" ? "Show" : "Hide"}</Button>
                                </div>
                            </Modal>
                            <CircularProgress color="inherit" />
                            </Backdrop>
                        </Row>
                    </Col>

                </Row>
            </Content>
        </Layout>
    )
}